import * as THREE from 'three';
import { Vehicle } from '../core/Vehicle';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader';

export class Forklift extends Vehicle {
  private model: THREE.Group | THREE.Object3D | null = null;

  constructor() {
    super();
    // Thiết lập các thông số phù hợp cho xe nâng
    this.maxSpeed = 1.2;
    this.acceleration = 0.025;
    this.deceleration = 0.03;
    this.turnSpeed = 0.05;
    
    // Thiết lập vị trí ban đầu và nâng cao hơn một chút
    this.mesh.position.set(0, 1.5, -495); // Tăng giá trị Y từ 0.5 lên 1.5
  }

  public async createModel(): Promise<void> {
    try {
      // Nạp cả file OBJ và MTL
      const mtlLoader = new MTLLoader();
      const materials = await new Promise<MTLLoader.MaterialCreator>((resolve, reject) => {
        mtlLoader.load(
          '/forklift/Forklift.mtl',
          resolve,
          undefined,
          reject
        );
      });
      
      materials.preload();
      const objLoader = new OBJLoader();
      objLoader.setMaterials(materials);
      
      this.model = await new Promise<THREE.Group>((resolve, reject) => {
        objLoader.load(
          '/forklift/Forklift.obj',
          resolve,
          undefined,
          reject
        );
      });
      
      // Giảm kích thước xuống 60% của kích thước ban đầu
      this.model.scale.set(0.01, 0.01, 0.01);
      this.model.rotation.y = Math.PI;
      
      // Điều chỉnh vị trí Y để nâng mô hình lên khỏi mặt đất
      this.model.position.y = 1.8; // Thử giá trị này và điều chỉnh nếu cần
      
      // Thêm mô hình vào mesh
      this.mesh.add(this.model);
      
    } catch (error) {
      console.error('Error loading forklift model:', error);
      
      // Tạo mô hình đơn giản nếu tải thất bại
      const geometry = new THREE.BoxGeometry(1.5, 1.2, 2.5);
      const material = new THREE.MeshPhongMaterial({ color: 0xFFA500 });
      const fallbackMesh = new THREE.Mesh(geometry, material);
      
      // Thêm phần nâng đơn giản
      const liftGeometry = new THREE.BoxGeometry(1, 0.1, 0.8);
      const liftMaterial = new THREE.MeshPhongMaterial({ color: 0x333333 });
      const liftMesh = new THREE.Mesh(liftGeometry, liftMaterial);
      liftMesh.position.set(10, -0.5, 1.5);
      
      fallbackMesh.add(liftMesh);
      this.mesh.add(fallbackMesh);
    }
  }
}